import * as React from "react";
import {connect} from "react-redux";
import User from "../../../../model/user/User";
import {option, Option} from "ts-option";
import Lead from "../../../../model/lead/Lead";
import {updateLeadAssignees} from "../../../../store/action/lead/lead";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import AgentSelector from "./AgentSelector";

interface IComponentProps {
	/**
	 * Selected agent id.
	 */
	agentId: Option<string>;
	/**
	 * On agent change callback.
	 * @param {User} user
	 */
	onChange?: (user: User) => void;
	/**
	 * Lead.
	 */
	lead?: Lead;
}

interface IDispatchProps {
	/**
	 * Update lead assignees action.
	 * @param {string} leadId
	 * @param {string[]} watchers
	 * @param {Option<string>} agentId
	 */
	updateAssignees: (leadId: string, agentId: Option<string>) => void;
}

type Props = IComponentProps & IDispatchProps;

class LeadAgentSelector extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<AgentSelector agentId={this.props.agentId} onChange={this.onChange}/>
		);
	}

	onChange(user: User) {
		if (this.props.onChange) {
			this.props.onChange(user);
		}
		if (this.props.lead) {
			this.props.updateAssignees(
				this.props.lead.id,
				option(user.id),
			);
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateAssignees: (leadId: string, agentId: Option<string>) => dispatch(
			updateLeadAssignees(
				leadId,
				agentId,
				() => Toast.success("Lead agent changed", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

export default connect(null, mapDispatchToProps)(LeadAgentSelector)